<ng-container *ngIf="pmaSingleHouses">
  <ui-single-house-address
    [form]="form"
    (setAccountId)="emitAccountId($event)"
    (emitAddressAttributes)="emitAddressAttributes($event)"
  ></ui-single-house-address>
</ng-container>

<ng-container *ngIf="!pmaSingleHouses">
  <ng-container *ngIf="!nonpreferredAddressSelection">
    <p class="section-title color_primary">{{ "tenant_boarding.choose_your_state" | translate }}</p>
    <div>
      <mat-form-field fxFlex="100%" appearance="outline">
        <mat-label>{{ 'form.state' | translate }}</mat-label>
        <mat-select data-testid="state" [formControl]="form.get('state')" id="state" required>
          <mat-option data-testid="state_option" *ngFor="let state of stateList;" [value]="state">{{state}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <div *ngIf="!nonpreferredAddressSelection; else addressSelection">
    <div>
      <div  [hidden]="progressiveRendering && !form.controls.state.value">
        <p class="section-title color_primary">{{ isBrandingSecondNature ? 'Choose Property' : isKioskProduct ? 'Retail Location' : 'Choose Community' }}</p>
        <div>
          <ui-community
            [stateControl]="form.get('state')"
            [communityControl]="communityControl"
            [unitControl]="form.get('unit')"
            [brandingId]="brandingId"
            [isKioskProduct]="isKioskProduct"
          ></ui-community>
        </div>
      </div>

      <div *ngIf="isBuildingControl" [hidden]="progressiveRendering && !communityControl.value">
        <p class="section-title color_primary">Choose Building</p>
        <div>
          <ui-building
            [buildings]="buildings"
            [buildingControl]="buildingControl"
            [unitControl]="form.get('unit')"
            [loader]="loader"
          ></ui-building>
        </div>
      </div>

      <div [hidden]="(progressiveRendering && !communityControl.value || (isBuildingControl && !buildingControl.value)) || isCommunitySkipUnits">
        <mat-error
          class="error-row"
          *ngIf="form.get('unit').touched && !units && !isCommunity">Please select a Community</mat-error>
        <p class="section-title color_primary">{{ isKioskProduct ? 'Unit/Space Number' : ("tenant_boarding.choose_your_unit" | translate) }}</p>
        <div>
          <ui-unit
            [unitControl]="form.get('unit')"
            [units]="units"
            [loader]="loader"
            [isKioskProduct]="isKioskProduct"
          ></ui-unit>
        </div>
      </div>
    </div>
  </div>
  <ng-template #addressSelection>
    <div class="pma-address-wrapper" fxLayout="column">
<!--      <ui-address-->
<!--        [form]="form"-->
<!--        (setBuildingsFromAddress)="setBuildingsFromAddress($event)"-->
<!--        (setUnitsFromAddress)="setUnitsFromAddress($event)"-->
<!--        (setAccountId)="emitAccountId($event)"-->
<!--        (setCommunity)="setCommunity($event)"-->
<!--      >-->
<!--      </ui-address>-->
      <ui-address-search
        [form]="form"
        [addressFormatV2Enabled]="addressFormatV2Enabled"
        (setBuildingsFromAddress)="setBuildingsFromAddress($event)"
        (setUnitsFromAddress)="setUnitsFromAddress($event)"
        (setAccountId)="emitAccountId($event)"
        (setCommunity)="setCommunity($event)"
        (addressInvalidated)="onAddressInvalidated()"
      ></ui-address-search>

      <div *ngIf="isBuildingControl">
        <p class="section-title color_primary">Choose Building</p>
        <div>
          <ui-building
            [buildings]="buildings"
            [buildingControl]="buildingControl"
            [unitControl]="form.get('unit')"
          ></ui-building>
        </div>
      </div>

      <div>
        <p class="section-title color_primary">{{ "tenant_boarding.choose_your_unit" | translate }}</p>
        <div>
          <ui-unit
            [unitControl]="form.get('unit')"
            [units]="units"
            [nonApplicableControl]="nonApplicableControl"
          ></ui-unit>
        </div>
      </div>
    </div>
  </ng-template>

</ng-container>
